import { createContext, useContext } from 'react';

export const CommunitiesFilterContext = createContext<(number | string)[]>([]);

export const useCommunitiesFilter = () => {
  return useContext(CommunitiesFilterContext);
};
